import { Component, computed, inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDivider } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { RouterLink } from '@angular/router';

import { AuthStore } from '../../auth/store/auth.store';
import { NotificationBadge } from '../../ui/notification-badge/notification-badge';
import { Button } from '../../ui/button/button';

interface NavItem {
  icon: string;
  label: string;
  route: string;
  badge?: number;
  badgePending?: boolean;
  dividerAfter?: boolean;
  isDisabled?: boolean;
  isHidden?: boolean;
}

@Component({
  selector: 'app-side-menu',
  imports: [
    RouterLink,
    MatListModule,
    MatIconModule,
    MatButtonModule,
    MatDivider,
    NotificationBadge,
    Button,
  ],
  templateUrl: './side-menu.html',
  styleUrl: './side-menu.scss',
})
export class SideMenu {
  readonly isOpen = signal(false);
  readonly authStore = inject(AuthStore);

  open(): void {
    this.isOpen.set(true);
  }

  close(): void {
    this.isOpen.set(false);
  }

  readonly navItems: NavItem[] = [
    { icon: 'home', label: 'Начало', route: '/home', dividerAfter: true },
    { icon: 'sell', label: 'Продажби', route: '/home' },
    { icon: 'vpn_key', label: 'Наеми', route: '/home', dividerAfter: true },
    { icon: 'notifications', label: 'Известия', route: '/home', badge: 24, badgePending: true },
    { icon: 'favorite', label: 'Любими', route: '/home', badge: 17, badgePending: false },

    { icon: 'groups', label: 'Брокери', route: '/brokers' },
    { icon: 'account_balance_wallet', label: 'Плащания', route: '/paymnets' },
    { icon: 'admin_panel_settings', label: 'Административен панел', route: '/admin-panel' },
    { icon: 'article', label: 'Моите обяви', route: '/my-listings' },
  ];

  navigationItems = computed(() => {
    return this.navItems.map((item) => {
      if (item.route === '/admin-panel') {
        const navItem: NavItem = { ...item, isHidden: !this.authStore.isAdmin() };

        return navItem;
      }

      if (
        ['/brokers', '/paymnets', '/admin-panel', '/my-listings'].includes(item.route) &&
        !this.authStore.isUserIndividual()
      ) {
        return { ...item, isDisabled: true };
      }

      return item;
    });
  });

  onNavItemClick(item: NavItem, event: MouseEvent): void {
    if (item.isDisabled) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    this.close();
  }
}
